import { getOidc } from './oidc'

/**
 * @example
 *
 * Add auth for client
 *
 * ```ts
 * import { client } from '@apis/gam-gallery-view/__generated__/client.gen'
 * client.interceptors.request.use(AuthInterceptor)
 * ```
 *
 * Opt-out request from Auth
 *
 * @example
 * ```ts
 * import { client } from '@apis/gam-gallery-view/__generated__/client.gen'
 * client.interceptors.request.eject(AuthInterceptor)
 * ```
 */
export const AuthInterceptor = async (request: Request): Promise<Request> => {
  const oidc = await getOidc()

  if (oidc.isUserLoggedIn) {
    const headers = request.headers
    headers.set(
      'Authorization',
      // about await in next statement https://docs.oidc-spa.dev/release-notes#id-5.-optional-assume-gettokens-is-an-async-function
      `Bearer ${(await oidc.getTokens()).accessToken}`,
    )
  }

  return request
}
